import { render, staticRenderFns } from "./CreatorDetailPortfolio.vue?vue&type=template&id=20739964&scoped=true&"
import script from "./CreatorDetailPortfolio.vue?vue&type=script&lang=js&"
export * from "./CreatorDetailPortfolio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20739964",
  null
  
)

export default component.exports